<template>
  <v-card class="pa-5" :style="{ border: '1px solid var(--primary-boarder-color)' }">
    <v-row class="pa-5 pb-0">
      <span class="text-h6 font-weight-medium">My Roles</span>
    </v-row>
    <v-row>
      <v-col>
        <v-list dense disabled>
          <v-list-item-group  v-for="(role, index) in roles" :key="index">
            <v-list-item>
              <v-list-item-icon class="my-4">
                <v-avatar color="#def6ff" size="30" class="icon-box">
                  <v-icon small color="#00B3FF">double_arrow</v-icon>
                </v-avatar>
              </v-list-item-icon>
              <v-row>
                <v-col cols="8" class="detail-value">{{ role.name }}</v-col>
              </v-row>
            </v-list-item>
            <v-divider  v-if="index < roles.length - 1" class="border-opacity-25"></v-divider>
          </v-list-item-group>
        </v-list>
      </v-col>
    </v-row>
  </v-card>
</template>

<style scoped>
.icon-box {
  border-radius: 30%;
}

.detail-value {
  color: #000000;
  font-weight: 400;
}
</style>

<script>
export default {
  props: ["roles"],
  methods: {
    
  },
};
</script>
